import { topicCollections } from '@/mocks/home';

const toneMap: Record<string, { chip: string; icon: string; hover: string }> = {
  primary: {
    chip: 'bg-primary-100 text-primary-700',
    icon: 'bg-primary-500 text-background-50',
    hover: 'group-hover:border-primary-300',
  },
  accent: {
    chip: 'bg-accent-100 text-accent-800',
    icon: 'bg-accent-500 text-foreground-950',
    hover: 'group-hover:border-accent-300',
  },
  secondary: {
    chip: 'bg-secondary-100 text-secondary-900',
    icon: 'bg-secondary-500 text-background-50',
    hover: 'group-hover:border-secondary-400',
  },
};

export default function TopicCollections() {
  return (
    <section id="topics" className="scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex flex-col gap-6 border-b border-background-300 pb-8 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.24em] text-primary-600">
              COLLECTIONS / 专题合集
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              按专题翻，比按时间翻更快
            </h2>
            <p className="mt-3 font-body text-sm leading-7 text-foreground-600">
              往期内容不按热度排，只按线索归堆。同一个话题的旧物料、旧原话、旧截图都收在同一个合集里，
              查历史时不用来回跳。
            </p>
          </div>
          <a
            href="#archive"
            className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部 6 个合集
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicCollections.map((item) => {
            const tone = toneMap[item.tone] ?? toneMap.primary;
            return (
              <a
                key={item.id}
                href="#archive"
                className={`group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors ${tone.hover}`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md ${tone.icon}`}
                  >
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className={`rounded-full px-2.5 py-1 font-label text-xs ${tone.chip}`}>
                    {item.count} 条
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {item.name}
                </h3>
                <p className="mt-2 flex-1 font-body text-sm leading-6 text-foreground-600">
                  {item.desc}
                </p>
                <span className="mt-4 flex items-center gap-1 font-label text-xs text-foreground-500 transition-colors group-hover:text-primary-700">
                  进入合集
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}